import { X } from "lucide-react";
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
    padding: "0",
    borderRadius: "10px",
    border: "none",
  },
  zIndex: "999",
  width: "auto",
  innerWidth: "auto",
};

const ModalWrapper = ({ children, open, title, onRequestClose }) => {
  return (
    <Modal style={customStyles} isOpen={open} onRequestClose={onRequestClose}>
      <div className="flex flex-col gap-2 ">
        <div className=" border-b border-gray-400 flex items-center justify-between px-2 py-2">
          <h4 className="font-semibold capitalize">{title}</h4>
          <X className="h-5 w-5 cursor-pointer" onClick={onRequestClose} />
        </div>
        <div className="px-4 py-4 h-auto max-h-[88vh] w-full ">{children}</div>
      </div>
    </Modal>
  );
};

export default ModalWrapper;
